<template>
  <div>
    <div v-show="FILTROS_SELECIONADOS.length > 0">
      <v-tooltip bottom open-delay="700">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" color="#FFF" class="mb-2">mdi-filter</v-icon>
        </template>
        <span>Filtros dos produtos listados abaixo</span>
      </v-tooltip>
    </div>

    <v-dialog v-model="dialog" width="1100" persistent content-class="bra-20" transition="dialog-top-transition">
      <v-card>
        <v-card-title primary-title class="pl-6 pr-4">
          <span class="font-20">Filtragem de produtos</span>

          <v-spacer />

          <v-btn color="#111" icon @click="dialog = false;EXIBIR_PRODUTOS = false;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

<!--        <v-divider />-->

        <v-card-text class="pt-2">
          <div class="ml-n2 mb-4">
            <v-switch v-model="semFiltros" :disabled="semFiltros" hide-details @click="removerTodosFiltros">
              <template #label>
                <span class="pl-2">Exibir todos os produtos sem aplicação de filtros</span>
              </template>
            </v-switch>

            <FiltroExibirProdutosInativos
              v-model="EXIBIR_PRODUTOS_INATIVOS_STORE"
              class="mt-3"
              ocultar_divisor
              color="primary"
            />
          </div>

          <div class="d-flex">
            <template v-for="(filtros_tipo, key) in filtros_por_tipos">
              <FiltrosTipo
                ref="filtrosTipoRef"
                :filtros="filtros_tipo"
                :style="{width: filtros_tipo.largura}"
                :key="key"
                :class="key !== 'movimentacao' ? 'pl-4' : ''"
                @filtros_selecionados="atualizarFiltroSelecionados"
              />

              <v-divider v-if="key !== 'curvas'" vertical :key="`${key}_`" />
            </template>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="aplicarFiltros">
            aplicar filtros
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CompraAPI from "../../../api/compra";
import {filtros_por_tipos} from "@/components/compra/FiltrosProdutos/FiltrosPorTipos";
import FiltrosTipo from "@/components/compra/FiltrosProdutos/FiltrosTipo.vue";
import FiltroExibirProdutosInativos from "@/components/compra/ProdutosGerais/Filtros/FiltroExibirProdutosInativos.vue";

export default {
  components: {
    FiltroExibirProdutosInativos,
    FiltrosTipo
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Boolean
  },
  data: () => ({
    atualizarFiltros: true,
    semFiltros: false,
    filtros_por_tipos,
    filtros_selecionados_por_tipo: [[], [], [], []]
  }),
  created() {
    this.atualizarFiltrosFornecedor();
  },
  destroyed() {
    this.FILTROS_SELECIONADOS = [];
  },
  computed: {
    ...mapGetters({
      fornecedorCompra: "fornecedor/getFornecedor",
      filialCompra: "usuario/getFilialCompras",
    }),
    dialog: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit('update:modelValue', valor);
      }
    },
    EXIBIR_PRODUTOS: {
      get() {
        return this.$store.getters['filtrosProdutos/get_exibir_produtos'];
      },
      set(valor) {
        this.$store.dispatch('filtrosProdutos/set_exibir_produtos', valor);
      }
    },
    FILTROS_SELECIONADOS: {
      get() {
        return this.$store.getters['filtrosProdutos/get_filtros'];
      },
      set(valor) {
        this.$store.dispatch('filtrosProdutos/set_filtros', valor);
      }
    },
    EXIBIR_PRODUTOS_INATIVOS_STORE: {
      get: function () {
        return this.$store.getters['CompraProdutosGerais/getExibirProdutosInativos'];
      },
      set: function (valor) {
        this.$store.dispatch('CompraProdutosGerais/getExibirProdutosInativos', valor);
      }
    },
    HISTOGRAMAS_STORE: {
      get() {
        return this.$store.getters['CompraProdutosGerais/getHistogramas'];
      },
      set(valor) {
        this.$store.dispatch('CompraProdutosGerais/setHistogramas', valor);
      }
    },
    APLICACAO_STORE: {
      get() {
        return this.$store.getters['CompraProdutosGerais/getAplicacao'];
      },
      set(valor) {
        this.$store.dispatch('CompraProdutosGerais/setAplicacao', valor);
      }
    },
  },
  watch: {
    dialog(valor) {
      if (valor) {
        this.EXIBIR_PRODUTOS = false;
      }
    },
    FILTROS_SELECIONADOS(valores) {
      this.semFiltros = valores.length <= 0;

      if (this.dialog && !this.semFiltros) {
        this.EXIBIR_PRODUTOS = true;
      }
    },
    HISTOGRAMAS_STORE(valores) {
      this.semFiltros = this.FILTROS_SELECIONADOS.length === 0 && valores.length === 0;

      if (this.dialog && valores.length > 0) {
        this.EXIBIR_PRODUTOS = true;
      }
    },
    APLICACAO_STORE(valores) {
      if (this.dialog && valores.length > 0) {
        this.EXIBIR_PRODUTOS = true;
      }
    }
  },
  methods: {
    atualizarFiltrosFornecedor() {
      if (this.atualizarFiltros) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          fornecedor: this.fornecedorCompra.id,
          filial: this.filialCompra,
        };

        CompraAPI.atualizarFiltrosProfutosFornecedor(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            this.atualizarFiltros = false;
          });
      }
    },
    removerTodosFiltros() {
      for (const ref of this.$refs.filtrosTipoRef) {
        ref.filtros_selecionados = [];
      }

      this.FILTROS_SELECIONADOS = [];

      const aplicacao_atual = this.$store.getters['CompraProdutosGerais/getAplicacao'];
      const nova_aplicacao = aplicacao_atual.filter(item =>
        item !== 'PRODUTO_EM_VENDA_FUTURA' &&
        item !== 'PRODUTO_EM_ANALISE_POR_LOTES'
      );

      this.$store.dispatch('CompraProdutosGerais/setAplicacao', nova_aplicacao);
      this.$store.dispatch('CompraProdutosGerais/setHistogramas', []);
    },
    atualizarFiltroSelecionados(ev) {
      this.filtros_selecionados_por_tipo[ev.tipo] = ev.filtros;
      this.FILTROS_SELECIONADOS = this.filtros_selecionados_por_tipo.flat();
    },
    aplicarFiltros() {
      this.dialog = false;
      this.EXIBIR_PRODUTOS = true;
    }
  },
};
</script>

<style scoped>
</style>
